import * as Yup from "yup";

// ? A year whose end falls before its start would swallow every service in the backfill, so the range is enforced
// ? here as well as on the server.
export const academicYear = {
  create: Yup.object().shape({
    key : Yup.string().required('شناسه سال الزامی است'),
    name: Yup.string().required('نام سال تحصیلی الزامی است'),

    startAt: Yup.string().required('تاریخ شروع الزامی است'),
    endAt  : Yup.string()
      .required('تاریخ پایان الزامی است')
      .test('after-start', 'تاریخ پایان باید بعد از تاریخ شروع باشد', function (value) {
        const { startAt } = this.parent;
        if (!startAt || !value) return true;
        return new Date(value) > new Date(startAt);
      }),

    isCurrent: Yup.boolean(),
  }),
};
